import { forwardRef } from 'react'

type Props = {
  digestMovie: string
}

export const RefWrappedDigestMovieContent = forwardRef<HTMLVideoElement, Props>(
  ({ digestMovie }, ref) => (
    <div className="flex lg:px-[8.7vw] pt-[8.3vw] lg:pt-[3.3vw] pb-[11.5vw] lg:pb-[4.3vw] bg-[#F7F6F5]">
      <video
        width="100%"
        height="100%"
        controls
        playsInline
        preload="metadata"
        src={digestMovie}
        ref={ref}
      ></video>
    </div>
  )
)
RefWrappedDigestMovieContent.displayName = 'DigestMovieContent'
